import React from "react";
import Icon from "../../_static/Icons";
import buildColor from "../../_static/ColorPalette";
import { successDouble } from "../../_static/Icons/iconsDuotone";

import {
  Container,
  Title,
  ListContainer,
  ListRow,
  RowDot,
  RowText
} from "./styled-components";

const RegistrationListItemMolecule = ({ stepQaLabel, title, list, isSsn }) => {
  return (
    <Container>
      {title && (
        <Title data-qa-label={`registration-list-${stepQaLabel}`}>
          {title}
        </Title>
      )}
      <ListContainer data-qa-label="list-container">
        {list.map(
          (
            {
              status,
              text,
              icon,
              color,
              viewBoxSize,
              colorList,
              strokeColorList,
              strokeWidthList,
              noMarginBottomLastChild = true,
              type = ""
            },
            index
          ) => {
            if (text && status) {
              if (status === "SUCCESS") {
                return (
                  <ListRow key={`${status}-${text}`}>
                    <Icon
                      qaLabel={`icon-${status.toLowerCase()}-${index}`}
                      icon={successDouble}
                      viewBoxSize={16}
                      color={buildColor("green", "100")}
                    />
                    <RowText
                      hasIcon
                      isSuccess
                      data-qa-label={`text-${status.toLowerCase()}-${index}`}
                    >
                      {text}
                    </RowText>
                  </ListRow>
                );
              }

              if (status === "COMMON" && icon && (color || colorList)) {
                return (
                  <ListRow
                    lastChild={isSsn && list.length - 1 === index}
                    noMarginBottomLastChild={noMarginBottomLastChild}
                    key={`${status}-${text}`}
                  >
                    <Icon
                      icon={icon}
                      viewBoxSize={viewBoxSize || 1024}
                      color={color}
                      size={32}
                      colorList={colorList}
                      strokeColorList={strokeColorList}
                      strokeWidthList={strokeWidthList}
                      qaLabel={`${
                        type !== "" ? `${type}-` : ""
                      }icon-${status.toLowerCase()}-${index}`}
                    />
                    <RowText
                      hasIcon
                      data-qa-label={`${
                        type !== "" ? `${type}-` : ""
                      }text-${status.toLowerCase()}-${index}`}
                    >
                      {text}
                    </RowText>
                  </ListRow>
                );
              }

              const isWarning = status === "WARNING";
              return (
                <ListRow key={`${status}-${text}`}>
                  <RowDot isWarning={isWarning} />
                  <RowText
                    isWarning={isWarning}
                    data-qa-label={`text-${status.toLowerCase()}-${index}`}
                  >
                    {text}
                  </RowText>
                </ListRow>
              );
            }

            return null;
          }
        )}
      </ListContainer>
    </Container>
  );
};

RegistrationListItemMolecule.defaultProps = {
  title: "",
  list: [],
  isSsn: false
};

export default RegistrationListItemMolecule;
